import React, { useState, useMemo, useCallback } from 'react';
import { TPropertiesOfPatchChangesForSubcategory } from 'types';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import SearchField from 'components/SearchField/SearchField';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import style from './MultipleSelect.module.scss';

interface IProps {
	setProperties: (value: TPropertiesOfPatchChangesForSubcategory[]) => void;
	properties: { id: TPropertiesOfPatchChangesForSubcategory; name: string }[];
	selectedProperties: string[];
}

export const MultipleSelect: React.FC<IProps> = React.memo(({ setProperties, properties, selectedProperties }) => {
	const [searchString, setSearchString] = useState<string>('');

	const filteredData = useMemo(() => {
		return searchString
			? properties.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase()))
			: properties;
	}, [searchString, properties]);

	const handleSelectAllData = useCallback(() => {
		if (properties.length === selectedProperties.length) {
			setProperties([]);
		} else {
			const IDsOfAllRestaurants = properties.map((el) => el.id);
			setProperties(IDsOfAllRestaurants);
		}
	}, [properties, selectedProperties, setProperties]);

	const renderSelectMenu = useCallback(
		(menu: React.ReactElement) => {
			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={!!(properties.length && properties.length === selectedProperties.length)}
							disabled={!properties.length}
							onChange={handleSelectAllData}>
							<Text
								translationNameSpace="form"
								translationKey="selectAllPropertiesLabel"
								asFragment={true}
							/>
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		},
		[properties, selectedProperties, handleSelectAllData, searchString, setSearchString],
	);

	return (
		<OutsideFormSelect
			testId="PropertiesMultipleSelect"
			name="properties"
			label="propertiesLabel"
			value={selectedProperties}
			options={filteredData}
			onChange={setProperties}
			mode="multiple"
			counterValue={selectedProperties.length}
			dropdownRender={renderSelectMenu}
		/>
	);
});
